import { createAction, props } from '@ngrx/store';
import { Credentials } from '../../../auth/model/user';

export const signin = createAction(
  '[Signin Page] Signin',
  props<{ credentials: Credentials, url: string }>()
);
export const autoLogin = createAction(
  '[Signin Page] Auto login',
  props<{url: string}>()
);
export const autoLogout = createAction('[Signin Page] Auto logout');


export type SigninPageActionsUnion = ReturnType<typeof signin | typeof autoLogin | typeof autoLogout>;
